import React, { useCallback, useRef } from "react";
import useClickOutside from "../../../hooks/useClickOutside";
import TreeSelectTrigger from "./treeSelectTrigger/TreeSelectTrigger";
import classes from "./TreeSelectField.module.css";

const TreeSelectField = ({ label, placeholder, chips, open, onToggle, onClose, children }) => {
    const ref = useRef(null);
    const handleClose = useCallback(() => onClose?.(), [onClose]);
    useClickOutside(ref, handleClose);

    return (
        <div className={classes.Field}>
            {label && <label className={classes.Label}>{label}</label>}
            <div ref={ref} className={classes.Wrapper}>
                <TreeSelectTrigger
                    open={open}
                    chips={chips}
                    placeholder={placeholder}
                    onToggle={onToggle}
                />
                {open && (
                    <div className={classes.Panel}>
                        {children}
                    </div>
                )}
            </div>
        </div>
    );
};

export default TreeSelectField;
